import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { CompteursAbsenceDto } from "../../../../../dto/GenApi.iNotPaie.Dto/CompteursAbsenceDto";
import { EventBus } from "../../../../Controls/EventBus";
import EventConstants, { RoleConstants } from "../../../../Controls/EventConstants";
import { ParametresInstance } from "../../../../Controls/Parameters";

@Component
export default class SituationSalarie extends Vue {
	public paieEnable = false;

	@Prop()
	public dataReady = false;

	@Prop()
	public anneeCouranteConges = new Date().getFullYear();

	@Prop()
	public compteurAbsences?: CompteursAbsenceDto = undefined;

	@Prop()
	public ficheSalarie = false;

	public initVariables(): void {
    	this.paieEnable = (ParametresInstance.societeCourante != undefined && ParametresInstance.societeCourante.IsPaieActive) || ParametresInstance.userIsAuthorized([RoleConstants.Administrateur]);
    	this.$emit("paieEnable", this.paieEnable);
	}

	public mounted(): void {
    	this.initVariables();
    	EventBus.$on(EventConstants.SOCIETE_CHANGED, () => {
    		this.initVariables();
    	});
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/situationDesAbsences/tableaux/situationSalarie/situationSalarie.ts